export default __webpack_public_path__ + "locales/nl/UploadPanel.json?hash=75c1d480ca7efbfcbc0d038a5bf4d04c";